module.exports = __webpack_public_path__ + "img/copy-icon.eb7523bc.svg";